export default __webpack_public_path__ + "static/media/ProximaNova-Bold.35476d63.woff";